import { CanMexCountyCode } from 'my-account/constants';
import { ChildModel, ModelBase } from 'store/model-base';
import { GtpSession } from './gtp-session';

export class GtpSessionCollection extends ModelBase {
    public static storeName: string = 'gtpSessionCollection';
    public static idAttribute: string = 'statementKey';

    public statementId: string;
    public gtpSessionCollection: GtpSession[];

    public canMexGtpPasses: GtpSession[];
    public restOfCountyGTPPasses: GtpSession[];

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.gtpSessionCollection = data.gtpSessionCollection || [];
        data.canMexGtpPasses = data.gtpSessionCollection.filter((session: GtpSession) => (session.countryCode === CanMexCountyCode.CAN || session.countryCode === CanMexCountyCode.MEX));
        data.restOfCountyGTPPasses = data.gtpSessionCollection.filter((session: GtpSession) => !(session.countryCode === CanMexCountyCode.CAN || session.countryCode === CanMexCountyCode.MEX));

        return super.create<T>(data);
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'gtpSessionCollection',
            model: GtpSession
        }];
    }
}
